module.exports = __webpack_public_path__ + "img/horizontal_3_2_r_8023.cccbab80.png";